module.exports = __webpack_public_path__ + "img/agency-contact-01.1f8c961f.jpg";